import React from "react";
import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  VStack,
  Button,
  Text,
  useTheme,
} from "@chakra-ui/react";
import { useToastContext } from "../../../toastNotificationProvider/ToastNotificationProvider";
import { useNavigate } from "react-router-dom";
import menuItems from "./menuItems";
const DashboardMenuItems = () => {
  const navigate = useNavigate();
  const { addNotification } = useToastContext();
  const theme = useTheme();
  const { primaryBlueLight, mainTextColor } = theme.colors.pallete;

  const routeMapping = {
    Subjects: "/subjects",
    Chapters: "/chapters",
    Topics: "/topics",
    "Sub Topics": null,
    Courses: "/courses",
    Assignments: "/assignment",
    Timetable: "/time-table",
    Packages: "/packages",
    "Schedule Class": "/class-schedule",
    Teachers:"/teacher-info",
    "Teacher Overview":"/teacher-overview"

  };

  const handleNavigation = (subOption) => {
    if (subOption === "Sub Topics") {
      addNotification(
        "Accessing this menu item is not yet available",
        "info",
        3000
      );
      return;
    }

    const path = routeMapping[subOption];
    if (path) {
      navigate(path);
    }
  };
  return (
    <Box
      scrollbar="hidden"
      height={"95vh"}
      // scrollBehavior={"smooth"}
      // overflowY="auto"
    >
      <Text
        fontWeight={"bold"}
        fontSize={"18px"}
        color={primaryBlueLight}
        textAlign="center"
        pt={4}
        pb={8}
      >
        Admin Panel
      </Text>

      <Accordion allowMultiple>
        {menuItems.map((item, index) => (
          <AccordionItem key={index} border="none">
            <AccordionButton _hover={{ bg: "gray.200" }}>
              <Box flex="1" textAlign="left" color={primaryBlueLight}>
                {item.title}
              </Box>
              <AccordionIcon color={primaryBlueLight} />
            </AccordionButton>

            <AccordionPanel pb={2} pl={4}>
              <VStack align="start" spacing={4}>
                {item.subOptions.map((sub, subIndex) => (
                  <Button
                    key={subIndex}
                    variant="link"
                    color={mainTextColor}
                    fontWeight="normal"
                    onClick={() => handleNavigation(sub)}
                  >
                    {sub}
                  </Button>
                ))}
              </VStack>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
};

export default DashboardMenuItems;
